import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colourMasterDarker, colourMaster, colourMasterSemiLight, colourMasterLight } from 'Styles/colors.css';

const Label = styled.label`
  width: ${props => (props.type === 'divider') ? '100%' : '30%'};
  text-align: left;
  opacity: .42;
  font-family: Montserrat;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  margin: 6px 0 0 0;
  align-self: baseline;
  padding-bottom: ${props => (props.type === 'divider') ? '5px' : '0'};
`;

const WveStyleElementLabel = ({ label = '', type = '' }) =>
  <Label
    htmlFor={label.trim()}
    type={type}
  >
    {label}
  </Label>;

WveStyleElementLabel.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
};

WveStyleElementLabel.defaultProps = {
  type: '',
};

export default WveStyleElementLabel;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel.jsx